import { Outlet } from "react-router-dom";

const Usuarios = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Usuarios;
